import React from 'react'

import { useTranslation } from 'react-i18next'

import { ClientFormWrapper } from '../common/styledComponents'


const Commissions = () => {
    const {t} = useTranslation()
    return (
        <ClientFormWrapper>
            <div>
                <strong>{t('home_affiliate_why')}</strong>
                <br></br>
                {t('home_affiliate_why_1')}
                <br></br>
                {t('home_affiliate_why_2')}
            </div>
            <div>
                <br></br>

                <strong> {t('monthly_commission')}</strong><br/>
                {t('monthly_commission_rate')}
                <br/><br/>
                PS: {t('monthly_commission_note')}
                <br/><br/>

                <strong>{t('yearly_commission')}</strong><br/>
                {t('yearly_rate_10')}<br/>
                {t('yearly_rate_20')}<br/>
                {t('yearly_rate_30')}<br/>
                {t('yearly_rate_40')}<br/>
                {t('yearly_rate_50')}<br/>
                {t('yearly_rate_60')}<br/>
                {t('yearly_rate_61')}<br/>

            </div>
            <div>
                <br />
                PS: {t('yearly_commission_note')}

                <br />
                <br />
                {t('commission_duration')}

                <br />
                <br />
                {t('min_payout')}
                <br/>{t('home_affiliate_how_4')}
            </div>
        </ClientFormWrapper>
    )
}

export default Commissions